import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";
import { SimpleLayoutType } from "config";

// Tasks Board
const TasksBoard = Loadable(lazy(() => import("apps/tasks-kanban-board")));

// Ventas
const VentasNuevaCotizacion = Loadable(lazy(() => import("pages/content/ventas/pedidos-venta/form")));
const VentasCotizaciones = Loadable(lazy(() => import("pages/content/ventas/cotizaciones")));
const VentasCotizacionesHistorico = Loadable(lazy(() => import("pages/content/ventas/cotizaciones/historico")));
const VentasPedidosVenta = Loadable(lazy(() => import("pages/content/ventas/pedidos-venta")));
const VentasPedidosVentaHistorico = Loadable(lazy(() => import("pages/content/ventas/pedidos-venta/historico")));
const VentasRemisiones = Loadable(lazy(() => import("pages/content/ventas/remisiones")));
const VentasRemisionesHistorico = Loadable(lazy(() => import("pages/content/ventas/remisiones/historico")));
const VentasFacturas = Loadable(lazy(() => import("pages/content/ventas/facturas")));
const VentasFacturasTimbrado = Loadable(lazy(() => import("pages/content/ventas/facturas/timbrado")));
const VentasNotasCredito = Loadable(lazy(() => import("pages/content/ventas/notas-credito")));
const VentasCxC = Loadable(lazy(() => import("pages/content/ventas/CxC")));
const VentasCxCHistorico = Loadable(lazy(() => import("pages/content/ventas/CxC/historico")));
const VentasCobranza = Loadable(lazy(() => import("pages/content/ventas/cobranza")));

// Operaciones
const OperacionesPedidosPorAutorizar = Loadable(lazy(() => import("pages/content/operaciones/pedidos-por-autorizar")));
const OperacionesExistenciasDisponibles = Loadable(lazy(() => import("pages/content/operaciones/existencias-disponibles")));

// Inventario
const InventarioLotes = Loadable(lazy(() => import("pages/content/inventario/lotes")));
const InventarioExistencias = Loadable(lazy(() => import("pages/content/inventario/existencias")));
const InventarioExistenciasMovimientos = Loadable(lazy(() => import("pages/content/inventario/existencias/existencias-movimientos")));
const InventarioAlmacenes = Loadable(lazy(() => import("pages/content/inventario/almacenes")));
const InventarioProductos = Loadable(lazy(() => import("pages/content/inventario/productos")));
const InventarioProductosProduccion = Loadable(lazy(() => import("pages/content/inventario/productos-produccion")));
const InventarioProductosPorLote = Loadable(lazy(() => import("pages/content/inventario/productos-por-lote")));
const InventarioProduccionExistenciasMovimientos = Loadable(lazy(() => import("pages/content/inventario/produccion-existencias-movimientos")));
const InventarioInsumosProduccion = Loadable(lazy(() => import("pages/content/inventario/insumos-produccion")));
const InventarioInsumosPorLote = Loadable(lazy(() => import("pages/content/inventario/insumos-por-lote")));
const InventarioSalidaInsumo = Loadable(lazy(() => import("pages/content/inventario/salida-insumo")));
        

//-------------------------------------
// Template pages routing
const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("pages/auth/register")));
const AuthForgotPassword = Loadable(lazy(() => import("pages/auth/forgot-password")));
const AuthResetPassword = Loadable(lazy(() => import("pages/auth/reset-password")));
const AuthResetPasswordResponse = Loadable(lazy(() => import("pages/auth/reset-password-confirmation")));
const AuthCheckMail = Loadable(lazy(() => import("pages/auth/check-mail")));
const AuthCodeVerification = Loadable(lazy(() => import("pages/auth/code-verification")));

const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(lazy(() => import("pages/maintenance/500")));
const MaintenanceUnderConstruction = Loadable(lazy(() => import("pages/maintenance/under-construction")));
const MaintenanceComingSoon = Loadable(lazy(() => import("pages/maintenance/coming-soon")));

//-------------------------------------
// pages routing

const DashboardRouter = Loadable(lazy(() => import("pages/content/dashboards/router")));
const DashboardPrincipal = Loadable(lazy(() => import("pages/content/dashboards/principal")));
const DashboardOperaciones = Loadable(lazy(() => import("pages/content/dashboards/operaciones")));
const DashboardVendedores = Loadable(lazy(() => import("pages/content/dashboards/vendedores")));
const DashboardProduccion = Loadable(lazy(() => import("pages/content/dashboards/produccion")));



// CRM
const Prospectos = Loadable(lazy(() => import("pages/content/crm/prospectos")));
const Interacciones = Loadable(lazy(() => import("pages/content/crm/interacciones")));
const ListadoInteracciones = Loadable(lazy(() => import("pages/content/crm/interacciones/listado")));
const Agenda = Loadable(lazy(() => import("pages/content/crm/agenda")));
const CitasAutomatizadas = Loadable(lazy(() => import("pages/content/crm/citas-automatizadas")));


// Reportes
const VentasMontos = Loadable(lazy(() => import("pages/content/reportes/ventas-montos")));
const VentasModelo = Loadable(lazy(() => import("pages/content/reportes/ventas-modelo")));
const GastosMensuales = Loadable(lazy(() => import("pages/content/reportes/gastos-mensuales")));
const GastosCategorias = Loadable(lazy(() => import("pages/content/reportes/gastos-categorias")));
const EstadoResultados = Loadable(lazy(() => import("pages/content/reportes/estado-resultados")));
const VentasUnidades = Loadable(lazy(() => import("pages/content/reportes/ventas-unidades")));
const Backorders = Loadable(lazy(() => import("pages/content/reportes/backorders")));

// Reportes Análisis
const ReportesVentas = Loadable(lazy(() => import("pages/content/reportes-analisis/reportes-ventas")));
const ComisionesVendedores = Loadable(lazy(() => import("pages/content/reportes-analisis/comisiones-vendedores")));
const AnalisisCartera = Loadable(lazy(() => import("pages/content/reportes-analisis/analisis-cartera")));
const DashboardComercial = Loadable(lazy(() => import("pages/content/reportes-analisis/dashboard-comercial")));

// Catalogos



//Catálogos
const CatalogosGastos = Loadable(lazy(() => import("pages/content/catalogos/conceptos-gastos")));
const Usuarios = Loadable(lazy(() => import("pages/content/catalogos/usuarios")));
const CatalogosUnidades = Loadable(lazy(() => import("pages/content/catalogos/unidades")));
const CatalogosInsumos = Loadable(lazy(() => import("pages/content/catalogos/insumos")));
const CatalogosProveedores = Loadable(lazy(() => import("pages/content/catalogos/proveedores")));
const CatalogosClientes = Loadable(lazy(() => import("pages/content/crm/clientes")));
const CatalogosListasPrecios = Loadable(lazy(() => import("pages/content/ventas/listas-precios")));
const CatalogosVendedores = Loadable(lazy(() => import("pages/content/catalogos/vendedores")));
const CatalogosZonasVentas = Loadable(lazy(() => import("pages/content/catalogos/zonas-ventas")));
const CatalogosCuentasContables = Loadable(lazy(() => import("pages/content/catalogos/cuentas-contables")));

//Catalogos de Sistema 
const CatalogosSistemaCondicionesPago = Loadable(lazy(() => import("pages/content/catalogos/condiciones-pago")));

// Nuevos catalogos
const CatalogosClientesEspecialidad = Loadable(lazy(() => import("pages/content/catalogos/clientes-especialidad")));
const CatalogosObjetivosVenta = Loadable(lazy(() => import("pages/content/catalogos/objetivos-venta")));

//Compras
const NuevaOrden = Loadable(lazy(() => import("pages/content/compras/nueva-orden")));
const RecepcionMercancia = Loadable(lazy(() => import("pages/content/compras/recepcion-mercancia")));
const RecepcionMercanciaDetalle = Loadable(lazy(() => import("pages/content/compras/recepcion-mercancia/recepcion-mercancia-detalle")));
const RecepcionMercanciaHistorico = Loadable(lazy(() => import("pages/content/compras/recepcion-mercancia/historico")));
const Ordenes = Loadable(lazy(() => import("pages/content/compras/ordenes-compra")));
const OrdenesDetalle = Loadable(lazy(() => import("pages/content/compras/ordenes-compra/ordenes-compra-detalle")));
const OrdenesHistorico = Loadable(lazy(() => import("pages/content/compras/ordenes-compra/historico")));
const Facturas = Loadable(lazy(() => import("pages/content/compras/facturas")));
const CxP = Loadable(lazy(() => import("pages/content/compras/CxP")));
const CxPHistorico = Loadable(lazy(() => import("pages/content/compras/CxP/historico")));
const PagosCompras = Loadable(lazy(() => import("pages/content/compras/pagos")));

//Cuenta
const DatosContacto = Loadable(lazy(() => import("pages/content/cuenta/datos-contacto")));
const EstadoCuenta = Loadable(lazy(() => import("pages/content/cuenta/estado-cuenta")));
const SoporteCuenta = Loadable(lazy(() => import("pages/content/cuenta/soporte")));




// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "home",
          children: [
            {
              path: "",
              element: <DashboardRouter />,
            },
          ],
        },
        {
          path: "dashboard",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DashboardRouter />,
            },
            {
              path: "principal",
              element: <DashboardPrincipal />,
            },
            {
              path: "operaciones",
              element: <DashboardOperaciones />,
            },
            {
              path: "produccion",
              element: <DashboardProduccion />,
            },
            {
              path: "vendedores",
              element: <DashboardVendedores />,
            },
          ],
        },
        {
          path: "compras",
          element: <PagesLayout />,
          children: [
            {
              path: "nueva-orden",
              element: <NuevaOrden />,
            },
            {
              path: "ordenes",
              element: <Ordenes />,
            },
            {
              path: "ordenes-compra/ordenes-compra-detalle",
              element: <OrdenesDetalle />,
            },
            {
              path: "ordenes-compra/historico",
              element: <OrdenesHistorico />,
            },
            {
              path: "recepcion-mercancia",
              element: <RecepcionMercancia />,
            },
            {
              path: "recepcion-mercancia/recepcion-mercancia-detalle",
              element: <RecepcionMercanciaDetalle />,
            },
            {
              path: "recepcion-mercancia/historico",
              element: <RecepcionMercanciaHistorico />,
            },
            {
              path: "facturas",
              element: <Facturas />,
            },
            {
              path: "CxP",
              element: <CxP />,
            },
            {
              path: "CxP/historico",
              element: <CxPHistorico />,
            },
            {
              path: "pagos",
              element: <PagosCompras />,
            },
          ],
        },
        {
          path: "ventas",
          element: <PagesLayout />,
          children: [
            {
              path: "nueva-cotizacion",
              element: <VentasNuevaCotizacion />,
            },
            {
              path: "cotizaciones",
              element: <VentasCotizaciones />,
            },
            {
              path: "cotizaciones/historico",
              element: <VentasCotizacionesHistorico />,
            },
            {
              path: "pedidos-venta",
              element: <VentasPedidosVenta />,
            },
            {
              path: "pedidos/historico",
              element: <VentasPedidosVentaHistorico />,
            },
            {
              path: "remisiones",
              element: <VentasRemisiones />,
            },
            {
              path: "remisiones/historico",
              element: <VentasRemisionesHistorico />,
            },
            {
              path: "facturas",
              element: <VentasFacturas />,
            },
            {
              path: "facturas/timbrado",
              element: <VentasFacturasTimbrado />,
            },
            {
              path: "notas-credito",
              element: <VentasNotasCredito />,
            },
            {
              path: "CxC",
              element: <VentasCxC />,
            },
            {
              path: "CxC/historico",
              element: <VentasCxCHistorico />,
            },
            {
              path: "cobranza",
              element: <VentasCobranza />,
            },
            {
              path: "listas-precios",
              element: <CatalogosListasPrecios />,
            },
          ],
        },
        {
          path: "operaciones",
          element: <PagesLayout />,
          children: [
            {
              path: "pedidos-por-autorizar",
              element: <OperacionesPedidosPorAutorizar />,
            },
            {
              path: "existencias-disponibles",
              element: <OperacionesExistenciasDisponibles />,
            },
          ],
        },
        {
          path: "inventario",
          element: <PagesLayout />,
          children: [
            {
              path: "lotes",
              element: <InventarioLotes />,
            },
            {
              path: "existencias",
              element: <InventarioExistencias />,
            },
            {
              path: "existencias/existencias-movimientos",
              element: <InventarioExistenciasMovimientos />,
            },
            {
              path: "almacenes",
              element: <InventarioAlmacenes />,
            },
            {
              path: "productos",
              element: <InventarioProductos />,
            },
            {
              path: "productos-produccion",
              element: <InventarioProductosProduccion />,
            },
            {
              path: "productos-por-lote",
              element: <InventarioProductosPorLote />,
            },
            {
              path: "produccion-existencias-movimientos",
              element: <InventarioProduccionExistenciasMovimientos />,
            },
            {
              path: "insumos-produccion",
              element: <InventarioInsumosProduccion />,
            },
            {
              path: "insumos-por-lote",
              element: <InventarioInsumosPorLote />,
            },
            {
              path: "salida-insumo",
              element: <InventarioSalidaInsumo />,
            },
          ],
        },
        
        {
          path: "crm",
          element: <PagesLayout />,
          children: [
            {
              path: "prospectos",
              element: <Prospectos />,
            },
            {
              path: "interacciones",
              children: [
                {
                  path: "",
                  element: <Interacciones />,
                },
                {
                  path: "listado",
                  element: <ListadoInteracciones />,
                },
              ],
            },
            {
              path: "agenda",
              element: <Agenda />,
            },
            {
              path: "clientes",
              element: <CatalogosClientes />,
            },
            {
              path: 'citas-automatizadas',
              element: <CitasAutomatizadas />,
            },
            
            
          
          ],
        },
        
        {
          path: "reportes",
          element: <PagesLayout />,
          children: [
            {
              path: "ventas-montos",
              element: <VentasMontos />,
            },
            {
              path: "ventas-modelo",
              element: <VentasModelo />,
            },
            {
              path: "gastos-mensuales",
              element: <GastosMensuales />,
            },
            {
              path: "gastos-categorias",
              element: <GastosCategorias />,
            },
            {
              path: "estado-resultados",
              element: <EstadoResultados />,
            },
            {
              path: "ventas-unidades",
              element: <VentasUnidades />,
            },
            {
              path: "backorders",
              element: <Backorders />,
            },
          ],
        },
        {
          path: "reportes-analisis",
          element: <PagesLayout />,
          children: [
            {
              path: "reportes-ventas",
              element: <ReportesVentas />,
            },
            {
              path: "comisiones-vendedores",
              element: <ComisionesVendedores />,
            },
            {
              path: "analisis-cartera",
              element: <AnalisisCartera />,
            },
            {
              path: "dashboard-comercial",
              element: <DashboardComercial />,
            },
          ],
        },
        {
          path: "catalogos",
          element: <PagesLayout />,
          children: [
            {
              path: "gastos",
              element: <CatalogosGastos />,
            },
            {
              path: "usuarios",
              element: <Usuarios/>,
            },
            {
              path: "unidades",
              element: <CatalogosUnidades/>,
            },
            {
              path: "insumos",
              element: <CatalogosInsumos/>,
            },
            {
              path: "proveedores",
              element: <CatalogosProveedores/>,
            },
            {
              path: "vendedores",
              element: <CatalogosVendedores/>,
            },
            {
              path: "zonas-ventas",
              element: <CatalogosZonasVentas/>,
            },
            {
              path: "condiciones-pago",
              element: <CatalogosSistemaCondicionesPago/>,
            },
            {
              path: "cuentas-contables",
              element: <CatalogosCuentasContables/>,
            },
            {
              path: "clientes-especialidad",
              element: <CatalogosClientesEspecialidad/>,
            },
            {
              path: "objetivos-venta",
              element: <CatalogosObjetivosVenta/>,
            },
          ],
        },

        {
          path: "cuenta",
          element: <PagesLayout />,
          children: [
            {
              path: "estado-cuenta",
              element: <EstadoCuenta/>,
            },
            {
              path: "datos-contacto",
              element: <DatosContacto/>
            },
            {
              path: "soporte",
              element: <SoporteCuenta/>
            },
          ],
        },
        {
          path: "tasks-board",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <TasksBoard />,
            },
          ],
        },
        
      ],
    },

    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "/auth",
      element: <PagesLayout />,
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "reset-password",
          element: <AuthResetPassword />,
        },
        {
          path: "reset-password-confirmation",
          element: <AuthResetPasswordResponse />,
        },
        {
          path: "check-mail",
          element: <AuthCheckMail />,
        },
        {
          path: "code-verification",
          element: <AuthCodeVerification />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
